import { StoreNames } from './StoreNames';

const DB_NAME = 'EGERDAU_DB';

const openDB = (storeName: StoreNames): Promise<IDBDatabase> => {
  return new Promise((resolve, reject) => {
    const request = indexedDB.open(DB_NAME);

    request.onupgradeneeded = () => {
      const db = request.result;

      if (!db.objectStoreNames.contains(storeName)) {
        db.createObjectStore(storeName, { keyPath: 'id', autoIncrement: true });
      }
    };

    request.onsuccess = () => {
      resolve(request.result);
    };

    request.onerror = (dbError) => {
      reject(`Error opening DB: ${(dbError.target as IDBRequest).error}`);
    };
  });
};

export const addItem = async <T>(
  storeName: StoreNames,
  item: T
): Promise<void> => {
  try {
    const db = await openDB(storeName);
    const transaction = db.transaction(storeName, 'readwrite');
    const store = transaction.objectStore(storeName);

    store.add(item);

    return new Promise<void>((resolve, reject) => {
      transaction.oncomplete = () => resolve();
      transaction.onerror = (transactionError) =>
        reject(
          `Error adding item: ${(transactionError.target as IDBRequest).error}`
        );
    });
  } catch (error) {
    console.error(error);
  }
};

export const getAllItems = async <T>(storeName: StoreNames): Promise<T[]> => {
  try {
    const db = await openDB(storeName);
    const transaction = db.transaction(storeName, 'readonly');
    const store = transaction.objectStore(storeName);
    const request = store.getAll();

    return new Promise((resolve, reject) => {
      request.onsuccess = () => resolve(request.result);
      request.onerror = (transactionError) =>
        reject(
          `Error fetching items: ${
            (transactionError.target as IDBRequest).error
          }`
        );
    });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const cleanStore = async (storeName: StoreNames): Promise<void> => {
  const db = await openDB(storeName);
  return new Promise((resolve, reject) => {
    const transaction = db.transaction(storeName, 'readwrite');
    const store = transaction.objectStore(storeName);

    store.clear();

    transaction.oncomplete = () => resolve();
    transaction.onerror = (transactionError) =>
      reject(
        `Error cleaning store ${storeName}: ${
          (transactionError.target as IDBRequest).error
        }`
      );
  });
};
